// import AOS from "aos";
// import React, { useEffect, useState } from "react";
// import { Helmet } from "react-helmet";
// import data from "../ApiUrl/meta_api.js";

// function WorkShop() {
//   const [meta, setMeta] = useState(null);

//   const fetchData = () => {
//     const HomeMeta = data[0]?.workshop_page;
//     if (HomeMeta) {
//       setMeta(HomeMeta);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//     AOS.init({
//       duration: 2000,
//       once: true,
//     });
//   }, []);

//   const para1 = [
//     "PLC Programming: Hands-on exercises with Mitsubishi, Siemens, and Allen-Bradley PLCs.",
//     "SCADA Development: Creating and managing real-time automation systems.",
//     "HMI Interfaces: Designing interactive and user-friendly control systems.",
//     "IoT Integration: Exploring how IoT and Industry 4.0 are revolutionizing automation.",
//     "Maintenance & Troubleshooting: Practical strategies for keeping systems efficient.",
//     "Mastery of essential automation tools and systems.",
//     "Practical skills to solve real-world automation challenges.",
//     "Certification of participation and learning.",
//     "Embedded Systems Design and Development: Explore microcontrollers and embedded systems to develop real-time industrial automation solutions.",
//     "VFD Programming and Implementation: Learn to configure, program, and optimize Variable Frequency Drives (VFDs) for industrial motor control and energy efficiency.",

//   ];

//   const para2 = [
//     "SEO Techniques: Learning the latest trends and strategies for optimization.",
//     "Social Media Marketing: Crafting impactful campaigns across platforms.",
//     "Content Strategy: Building a compelling narrative for online audiences.",
//     "PPC Advertising: Running efficient and cost-effective ad campaigns.",
//     "Data Analytics: Using tools like Google Analytics to drive decisions.",
//     "Direct application of strategies to real-time projects.",
//     "Certification to enhance your professional profile.",
//     "Exposure to modern marketing tools and platforms.",
//     "Certification of participation and learning.",
//   ];

//   return (
//     <>
//       <Helmet>
//         <title>{meta ? meta.title : "WorkShop"}</title>
//         <link rel="canonical" href="https://skimitaracademy.com/workshops" />
//       </Helmet>

//       {/* Banner Section */}
//       <div
//         className="backgroundCommenImage mb-4 mb-md-5"
//         style={{
//           backgroundImage: `url(${require("../../assets/images/Intern/WorkShop/close-up-people-learning-job.webp")})`,
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//           backgroundRepeat: "no-repeat",
//           height: "clamp(200px, 30vw, 350px)",
//           width: "100%",
//           position: "relative",
//         }}
//       >
//         <div className="backgroundcommenImageBannerText"></div>
//       </div>

//       {/* Introduction Section */}
//       <div className="container mb-4 mb-md-5 px-3 px-md-4">
//         <h1
//           className="text-danger text-center mb-3 mb-md-4"
//           style={{ fontSize: "clamp(1.5rem, 4vw, 2.5rem)" }}
//         >
//           Workshops: Hands-On Learning for Real-World Impact
//         </h1>
//         <p
//           className="mb-0"
//           style={{
//             fontSize: "clamp(14px, 2vw, 16px)",
//             lineHeight: "1.6",
//             textAlign: "justify",
//           }}
//         >
//           Skimitar Hindusthan Training Institute, our workshops are designed to
//           provide participants with practical, hands-on training in Industrial
//           Automation and Digital Marketing. With a focus on real-world
//           applications, these workshops empower individuals to gain in-depth
//           knowledge and build skills that are immediately applicable in their
//           careers.
//         </p>
//       </div>

//       {/* Industrial Automation Section */}
//       <div
//         className="container-fluid py-4 py-md-5"
//         style={{ backgroundColor: "#1C2254" }}
//       >
//         <div className="container">
//           <div className="row align-items-start">
//             <div className="col-12 col-lg-5 order-2 order-lg-1 mb-4 mb-lg-0 d-flex justify-content-center">
//               <img
//                 className="img-fluid rounded"
//                 alt="Industrial Automation Workshop"
//                 src={require("../../assets/images/Intern/WorkShop/industrial-employees-working-together-factory-production-line.webp")}
//                 style={{
//                   // maxHeight: "500px",
//                   height: "500px",
//                   width: "100%",
//                   objectFit: "cover",
//                   marginTop:"55px"
//                 }}
//               />
//             </div>

//             <div className="col-12 col-lg-7 order-1 order-lg-2">
//               <h2
//                 className="text-danger mb-3 mb-md-4"
//                 style={{ fontSize: "clamp(1.3rem, 3vw, 1.8rem)" }}
//               >
//                 Industrial Automation Workshops
//               </h2>

//               <p
//                 className="text-white mb-4"
//                 style={{
//                   fontSize: "clamp(14px, 2vw, 16px)",
//                   lineHeight: "1.6",
//                   textAlign: "justify",
//                 }}
//               >
//                 Our Industrial Automation workshops offer a unique opportunity
//                 to work with the latest tools and technologies used in the
//                 industry. Participants will engage in:
//               </p>

//               {para1.map((item, index) => (
//                 <div key={index} className="d-flex align-items-start mb-3">
//                   <div className="flex-shrink-0 me-3 mt-1">
//                     <i
//                       className="fa-solid fa-circle"
//                       style={{
//                         color: "#dc3545",
//                         fontSize: "8px",
//                       }}
//                     ></i>
//                   </div>
//                   <p
//                     className="text-white mb-0 flex-grow-1"
//                     style={{
//                       fontSize: "clamp(13px, 1.8vw, 15px)",
//                       lineHeight: "1.5",
//                       textAlign: "justify",
//                     }}
//                   >
//                     {item}
//                   </p>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Digital Marketing Intro Section */}
//       <div className="container mt-4 mt-md-5 mb-4 mb-md-5 px-3 px-md-4">
//         <h2
//           className="text-danger text-center mb-3 mb-md-4"
//           style={{ fontSize: "clamp(1.3rem, 3vw, 1.8rem)" }}
//         >
//           Digital Marketing Workshops
//         </h2>

//         <p
//           className="mb-0"
//           style={{
//             fontSize: "clamp(14px, 2vw, 16px)",
//             lineHeight: "1.6",
//             textAlign: "justify",
//           }}
//         >
//           Dive into the dynamic world of Digital Marketing with workshops
//           tailored for aspiring marketers and professionals. Digital marketing
//           workshops are specialized training sessions designed to equip
//           individuals and businesses with the skills needed to excel in the
//           ever-evolving online marketplace. These workshops cover key areas such
//           as search engine optimization (SEO), social media marketing, email
//           campaigns, content creation, analytics, and pay-per-click advertising.
//           By blending theoretical concepts with hands-on practical exercises,
//           participants gain valuable insights into crafting effective digital
//           strategies.
//         </p>
//       </div>

//       {/* Digital Marketing Section */}
//       <div
//         className="container-fluid py-4 py-md-5"
//         style={{ backgroundColor: "#1C2254" }}
//       >
//         <div className="container">
//           <div className="row align-items-start">
//             <div className="col-12 col-lg-7 mb-4 mb-lg-0">
//               <h2
//                 className="text-danger mb-3 mb-md-4"
//                 style={{ fontSize: "clamp(1.3rem, 3vw, 1.8rem)" }}
//               >
//                 Key Topics
//               </h2>

//               {para2.map((item, index) => (
//                 <div key={index} className="d-flex align-items-start mb-3">
//                   <div className="flex-shrink-0 me-3 mt-1">
//                     <i
//                       className="fa-solid fa-circle"
//                       style={{
//                         color: "#dc3545",
//                         fontSize: "8px",
//                       }}
//                     ></i>
//                   </div>
//                   <p
//                     className="text-white mb-0 flex-grow-1"
//                     style={{
//                       fontSize: "clamp(13px, 1.8vw, 15px)",
//                       lineHeight: "1.5",
//                       textAlign: "justify",
//                     }}
//                   >
//                     {item}
//                   </p>
//                 </div>
//               ))}
//             </div>

//             <div className="col-12 col-lg-5 d-flex justify-content-center align-items-start">
//               <img
//                 className="img-fluid rounded"
//                 alt="Digital Marketing Workshop"
//                 src={require("../../assets/images/Intern/WorkShop/pexels-gustavo-fring-6285124.webp")}
//                 style={{
//                   height: "400px",
//                   width: "100%",
//                   objectFit: "cover",
//                   marginTop:"40px"
//                 }}
//               />
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Bottom Content Section */}
//       <div className="container mt-4 mt-md-5 mb-4 mb-md-5 px-3 px-md-4">
//         <div className="row">
//           <div className="col-12">
//             <div
//               className="p-3 p-md-4 rounded"
//               style={{ backgroundColor: "#f8f9fa" }}
//             >
//               <p
//                 className="text-dark mb-3"
//                 style={{
//                   fontSize: "clamp(14px, 2vw, 16px)",
//                   lineHeight: "1.6",
//                   textAlign: "justify",
//                 }}
//               >
//                 A workshop on digital marketing offers participants an in-depth
//                 understanding of strategies and tools to enhance online
//                 visibility, reach target audiences, and drive business growth.
//                 Participants learn key concepts such as SEO, social media
//                 marketing, email campaigns, and analytics. Through hands-on
//                 sessions, they explore creating impactful digital content,
//                 managing ad campaigns, and interpreting data insights to make
//                 informed decisions.
//               </p>

//               <p
//                 className="text-dark mb-0"
//                 style={{
//                   fontSize: "clamp(14px, 2vw, 16px)",
//                   lineHeight: "1.6",
//                   textAlign: "justify",
//                 }}
//               >
//                 An industrial automation workshop provides a practical
//                 introduction to the latest technologies revolutionizing the
//                 manufacturing and production sectors. Participants gain insights
//                 into concepts such as PLC programming, robotics, IoT
//                 integration, and smart manufacturing. Hands-on sessions allow
//                 attendees to work with automation tools and understand
//                 real-world applications, including process optimization, cost
//                 efficiency, and improved safety.
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default WorkShop;



import React, { useRef, useEffect } from 'react';
import course_bg from '../../assets/img/OurCourse/course-bg.jpg';
import '../../assets/css/Ourcourse.css';

// Icons from Workshop
import expert_icon from "../../assets/icons/expert-instructer.png";
import hands_on_lab from "../../assets/icons/hands-on-lab.png";
import industry_certificate from "../../assets/icons/industry-certificate.png";
import flexiable_learn from "../../assets/icons/flexiable-learning.png";
import placement_icon from "../../assets/icons/palcement-icon.png";
import industry_icon from "../../assets/icons/industry-icon.png";
import clock_icon from '../../assets/icons/clock-icon.png';

// // Partner Logos
// import APP_logo from "../../assets/img/Logo/logo-6.jpg";
// import mitsubishi from "../../assets/img/Logo/logo-1.jpg";
// import siemens from "../../assets/img/Logo/logo-2.jpg";
// import rockwell from "../../assets/img/Logo/logo-5.jpg";
// import delta from "../../assets/img/Logo/logo-3.jpg";
// import omron from "../../assets/img/Logo/logo-4.jpg";

// ─── Scroll Reveal Hook ─────────────────────────────────
function useScrollReveal(ref) {
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.opacity = '0';
    el.style.transform = 'translateY(40px)';

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.style.transition = 'all 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
          el.style.opacity = '1';
          el.style.transform = 'translateY(0)';
          observer.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
}

// ─── Level Colors (if needed) ─────────────────────────────────
const LEVEL_COLOR = {
  'Beginner': '#1D9E75',
  'Intermediate': '#cc8800',
  'Advanced': '#cc0000',
};

// ─── Data from Workshop ───────────────────────────────────────
const whyCards = [
  { icon: expert_icon, title: "Expert Instructors", desc: "Learn from certified automation engineers with 10+ years of hands-on industry experience." },
  { icon: hands_on_lab, title: "Hands-On Lab Training", desc: "Practice on genuine industrial hardware — Siemens, Allen-Bradley, Mitsubishi, Schneider." },
  { icon: industry_certificate, title: "Industry-Recognised Certification", desc: "Earn certifications valued by manufacturing and process industries across India." },
  { icon: flexiable_learn, title: "Flexible Learning Modes", desc: "Classroom, live online, or hybrid training to fit your schedule." },
  { icon: placement_icon, title: "Placement Assistance", desc: "Resume building, mock interviews, and direct job referrals." },
  { icon: industry_icon, title: "Industry 4.0 Curriculum", desc: "Updated syllabus covering IIoT, Industry 4.0 and latest automation technologies." },
];

const faqItems = [
  { q: "What is industrial automation training and why is it important?", a: "Industrial automation training equips engineers and technicians with skills to design, program, operate, and maintain automated systems using PLCs, SCADA, HMI, robotics, and industrial networks." },
  { q: "Who should enrol in these courses?", a: "These programs are ideal for B.E./B.Tech graduates, diploma holders, ITI students, and working professionals seeking skill upgrades or a domain switch into the automation industry." },
  { q: "What certifications will I receive?", a: "You receive an industry-recognised certification from Skimitar Hindusthan, aligned with real-world competencies tested by employers." },
  { q: "Are courses available in online mode?", a: "Yes. We offer in-person classroom training at our Salem and Erode centres, live online sessions, and hybrid modes." },
  { q: "What career roles can I target?", a: "PLC Engineer, SCADA Operator, Automation Technician, Control Systems Engineer, DCS Engineer, Maintenance Engineer, and Industrial IoT Developer." },
  { q: "Is placement support included?", a: "Yes. Every enrolled student receives dedicated placement support including resume building, mock interviews and job referrals." },
];

// const partnerLogos = [
//   { name: "Mitsubishi", img: mitsubishi },
//   { name: "ABB", img: APP_logo },
//   { name: "Siemens", img: siemens },
//   { name: "Rockwell", img: rockwell },
//   { name: "Delta", img: delta },
//   { name: "Omron", img: omron },
// ];

const journeySteps = [
  { label: "Assess Your Training Goals", desc: "Identify your current skill level and the automation domain that aligns with your career target." },
  { label: "Choose the Right Program", desc: "Select from beginner, intermediate, or advanced certification programs." },
  { label: "Gain Hands-On Experience", desc: "Work on real automation equipment and live industry projects." },
  { label: "Get Certified & Get Hired", desc: "Complete your certification and access full placement support." },
];

// Workshop Topics
const automationTopics = [
  { icon: "⚙️", title: "PLC Programming", desc: "Hands-on exercises with Mitsubishi, Siemens, and Allen-Bradley PLCs." },
  { icon: "🖥️", title: "SCADA Development", desc: "Create and manage real-time industrial automation systems." },
  { icon: "🎛️", title: "HMI Interface Design", desc: "Design interactive, user-friendly control panels." },
  { icon: "🌐", title: "IoT & Industry 4.0 Integration", desc: "Explore how Industrial IoT is revolutionising automation." },
  { icon: "🔧", title: "Maintenance & Troubleshooting", desc: "Practical strategies to diagnose faults and reduce downtime." },
  { icon: "🤖", title: "Embedded Systems Design", desc: "Develop real-time industrial automation solutions." },
  { icon: "⚡", title: "VFD Programming & Implementation", desc: "Configure and optimise Variable Frequency Drives." },
  { icon: "🏆", title: "Certification of Participation", desc: "Earn an industry-recognised certificate." },
];

const marketingTopics = [
  { icon: "🔍", title: "SEO Techniques", desc: "Master the latest search engine optimisation strategies." },
  { icon: "📱", title: "Social Media Marketing", desc: "Craft high-impact campaigns across Meta, Instagram, LinkedIn." },
  { icon: "✍️", title: "Content Strategy", desc: "Build compelling narratives and content calendars." },
  { icon: "💰", title: "PPC Advertising", desc: "Run cost-effective Google Ads and Meta Ads campaigns." },
  { icon: "📊", title: "Data Analytics & GA4", desc: "Use Google Analytics 4 to turn data into decisions." },
  { icon: "📧", title: "Email Campaign Management", desc: "Design automated email sequences." },
  { icon: "🎯", title: "Direct Application to Live Projects", desc: "Apply every strategy to real-time campaigns." },
  { icon: "🏆", title: "Professional Certification", desc: "Receive a verified digital marketing certificate." },
];

// ─── Course Card (Simple for Workshop style) ─────────────────
function TopicCard({ item }) {
  return (
    <div className="col-12 col-md-6 col-lg-3 mb-4">
      <div className="card h-100 border-0 shadow-sm rounded-3 cr-topic-card">
        <div className="card-body p-4 text-center d-flex flex-column">
          <div className="mb-3" style={{ fontSize: '32px' }}>{item.icon}</div>
          <h5 className="fw-bold mb-3 cr-topic-title">{item.title}</h5>
          <p className="text-muted flex-grow-1 cr-topic-desc" style={{ fontSize: '15px' }}>{item.desc}</p>
        </div>
      </div>
    </div>
  );
}

// ─── Main Workshop Component (as OurCourse Style) ─────────────
const WorkShop = () => {
  const heroRef = useRef(null);
  useScrollReveal(heroRef);

  return (
    <div className="career-page" style={{ fontFamily: "'Poppins', sans-serif" }}>

      {/* 1. HERO */}
      <section className="cr-hero-section position-relative overflow-hidden" ref={heroRef}>
        <div
          className="cr-hero-bg position-absolute w-100 h-100"
          style={{
            backgroundImage: `linear-gradient(rgba(0,0,0,0.65), rgba(0,0,0,0.75)), url(${course_bg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        ></div>

        <div className="container cr-container position-relative" style={{ zIndex: 2 }}>
          <div className="d-flex align-items-center justify-content-center gap-3 mb-3">
            <span className="text-white fw-semibold px-3 py-1 rounded-4" style={{ background: '#cc0000', fontSize: '15px' }}>
              Workshops 2025-26
            </span>
          </div>
          <h1 className="cr-hero-title text-white text-center fw-bold mb-3">
            Hands-On Workshops.<br />
            <em className="text-primary-red">Real Skills. Real Careers.</em>
          </h1>
          <p className="cr-hero-sub text-center mx-auto">
            Intensive training in Industrial Automation & Digital Marketing with real equipment and live projects.
          </p>
        </div>
      </section>

      {/* 2. ABOUT */}
      {/* <section className="py-5 cr-margin-top">
        <div className="container cr-container">
          <div className="row g-5 align-items-center">
            <div className="col-lg-6">
              <img
                src={require("../../assets/images/Services/IAT/Pros And Cons of AI In Manufacturing.webp")}
                alt="Workshop Training"
                className="img-fluid rounded-3 shadow"
              />
            </div>
            <div className="col-lg-6">
              <span className="cr-sec-label text-uppercase fw-semibold text-primary-red">About Our Workshops</span>
              <h2 className="cr-section-title fw-bold text-uppercase mt-3 mb-4">
                One Partner.<br />Every Skill. Every Stage.
              </h2>
              <p style={{ fontSize: '15px', lineHeight: '1.75' }}>
                At Skimitar Hindusthan, our workshops deliver practical, hands-on training in Industrial Automation and Digital Marketing.
                Every session is structured around real equipment, live tools, and industry projects.
              </p>
            </div>
          </div>
        </div>
      </section> */}

      {/* Introduction Section */}
      <div className="container mb-4 mt-5 mb-md-5 px-3 px-md-4">
        <p className='text-center fw-bold text-dark fs-1'>About US</p>
        <h1
          className="text-danger text-center mb-3 mb-md-4"
          style={{ fontSize: "clamp(1.5rem, 4vw, 2.5rem)" }}
        >
          Workshops: Hands-On Learning for Real-World Impact
        </h1>
        <p
          className="mb-0"
          style={{
            fontSize: "clamp(14px, 2vw, 16px)",
            lineHeight: "1.6",
            textAlign: "justify",
          }}
        >
          Skimitar Hindusthan Training Institute, our workshops are designed to
          provide participants with practical, hands-on training in Industrial
          Automation and Digital Marketing. With a focus on real-world
          applications, these workshops empower individuals to gain in-depth
          knowledge and build skills that are immediately applicable in their
          careers.
        </p>
      </div>

      {/* 3. WHY CHOOSE US */}
      <section className="py-5 bg_color cr-margin-top">
        <div className="container cr-container">
          <div className="mb-5 text-center">
            <span className="cr-sec-label text-uppercase fw-semibold text-primary-red">Why Us</span>
            <h2 className="cr-section-title fw-bold text-uppercase mt-2">Why Choose Skimitar Hindusthan Workshops?</h2>
          </div>
          <div className="row g-4">
            {whyCards.map((item, i) => (
              <div key={i} className="col-md-6 col-lg-4">
                <div className="card h-100 border-0 shadow-sm rounded-3 p-4 text-center">
                  <img src={item.icon} alt={item.title} style={{ width: '50px', height: '50px', margin: '0 auto 15px' }} />
                  <h5 className="fw-bold text-primary-red mb-3">{item.title}</h5>
                  <p style={{ fontSize: '15px' }}>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 4. INDUSTRIAL AUTOMATION TOPICS */}
      <section className="py-5 cr-margin-top">
        <div className="container cr-container">
          <div className="mb-5 text-center">
            <span className="cr-sec-label text-uppercase fw-semibold text-primary-red">Workshop Track 01</span>
            <h2 className="cr-section-title fw-bold text-uppercase mt-2">Industrial Automation Workshops</h2>
          </div>
          <div className="row g-4">
            {automationTopics.map((item, i) => (
              <TopicCard key={i} item={item} />
            ))}
          </div>
        </div>
      </section>

      {/* 5. DIGITAL MARKETING TOPICS */}
      <section className="py-5 cr-margin-top bg_color">
        <div className="container cr-container">
          <div className="mb-5 text-center">
            <span className="cr-sec-label text-uppercase fw-semibold text-primary-red">Workshop Track 02</span>
            <h2 className="cr-section-title fw-bold text-uppercase mt-2">Digital Marketing Workshops</h2>
          </div>
          <div className="row g-4">
            {marketingTopics.map((item, i) => (
              <TopicCard key={i} item={item} />
            ))}
          </div>
        </div>
      </section>



      {/* 7. FAQ */}
      <section className="py-5 cr-margin-top">
        <div className="container cr-container">
          <div className="mb-5 text-center">
            <span className="cr-sec-label text-uppercase fw-semibold text-primary-red">FAQ</span>
            <h2 className="cr-section-title fw-bold text-uppercase mt-2">Frequently Asked Questions</h2>
          </div>
          <div className="accordion" id="faqAccordion">
            {faqItems.map((item, i) => (
              <div className="accordion-item border-0 shadow-sm mb-3" key={i}>
                <h2 className="accordion-header">
                  <button
                    className={`accordion-button fw-semibold ${i !== 0 ? 'collapsed' : ''}`}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#faq${i}`}
                  >
                    {item.q}
                  </button>
                </h2>
                <div id={`faq${i}`} className={`accordion-collapse collapse ${i === 0 ? 'show' : ''}`} data-bs-parent="#faqAccordion">
                  <div className="accordion-body" style={{ fontSize: '15px', lineHeight: '1.75' }}>
                    {item.a}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>


      <section>
        <div className="container mt-4 mt-md-5 mb-4 mb-md-5 px-3 px-md-4">
          <div className="row">
            <div className="col-12">
              <div
                className="p-3 p-md-4 rounded"
                style={{ backgroundColor: "#f8f9fa" }}
              >
                <p
                  className="text-dark mb-3"
                  style={{
                    fontSize: "clamp(14px, 2vw, 16px)",
                    lineHeight: "1.6",
                    textAlign: "justify",
                  }}
                >
                  A workshop on digital marketing offers participants an in-depth
                  understanding of strategies and tools to enhance online
                  visibility, reach target audiences, and drive business growth.
                  Participants learn key concepts such as SEO, social media
                  marketing, email campaigns, and analytics. Through hands-on
                  sessions, they explore creating impactful digital content,
                  managing ad campaigns, and interpreting data insights to make
                  informed decisions.
                </p>
                <p
                  className="text-dark mb-0"
                  style={{
                    fontSize: "clamp(14px, 2vw, 16px)",
                    lineHeight: "1.6",
                    textAlign: "justify",
                  }}
                >
                  An industrial automation workshop provides a practical
                  introduction to the latest technologies revolutionizing the
                  manufacturing and production sectors. Participants gain insights
                  into concepts such as PLC programming, robotics, IoT
                  integration, and smart manufacturing. Hands-on sessions allow
                  attendees to work with automation tools and understand
                  real-world applications, including process optimization, cost
                  efficiency, and improved safety.
                </p>
              </div>
            </div>
          </div>
        </div >
      </section>

      {/* 8. CTA */}
      <section className="" style={{ marginTop: '100px' }}>
        <div className="p-5" style={{ background: '#cc0000' }}>
          <div className="d-flex align-items-center justify-content-center gap-3 mb-3">
            <div className="bg-light" style={{ width: '40px', height: '1px' }} />
            <span
              className="text-uppercase fw-semibold text-white text-opacity-75"
              style={{ letterSpacing: "2px", whiteSpace: "nowrap", fontSize: "13px" }}
            >
              Start Your Automation Career
            </span>
            <div className="bg-light" style={{ width: '40px', height: '1px' }} />
          </div>
          <div className="row g-4 align-items-center">
            <div className="col-lg-7 text-center text-lg-start">
              <h2 className="fw-bolder text-white text-uppercase mb-3 iat-sec-title">
                Your Automation Career Starts at <b>Skimitar Hindusthan</b>
              </h2>
              <p className="text-white text-opacity-75 mb-0" style={{ lineHeight: "1.75" }}>
                Join thousands of students who chose structured automation training, built real hands-on
                skills, and launched successful careers — with <b>Skimitar Hindusthan's</b> practical,
                industry-aligned programs and dedicated placement support at every step.
              </p>
            </div>
            <div className="col-lg-5">
              <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center justify-content-lg-end">
                <button className="btn iat-btn-white px-4 py-3 fw-bold text-uppercase">
                  Explore All Courses →
                </button>
                <button className="btn iat-btn-ghost px-4 py-3 fw-bold text-uppercase">
                  📞 (+91) 8428010909
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WorkShop;